import { useMediaQuery } from '@vueuse/core';
import { BREAKPOINT } from '@/shared/constant';

export default () => {
	const isMobile = useMediaQuery(`(max-width: ${BREAKPOINT.md - 0.1}px)`);
	const isTablet = useMediaQuery(`(min-width: ${BREAKPOINT.md}px)`);
	const isLaptop = useMediaQuery(`(min-width: ${BREAKPOINT.lg}px)`);
	const isLaptopMedium = useMediaQuery(`(min-width: ${BREAKPOINT.lg1}px)`);
	const isLaptopBig = useMediaQuery(`(min-width: ${BREAKPOINT.lg2}px)`);
	const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINT.xl}px)`);

	return {
		isMobile,
		isTablet,
		isLaptop,
		isLaptopMedium,
		isLaptopBig,
		isDesktop,
	};
};
